import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-footer-element',
    templateUrl: './footer-element.component.html',
    styleUrls: ['./footer-element.component.scss'],
    standalone: false,
})
export class FooterElementComponent {
    @Input() message = '';
    @Input() email = '';
    @Input() url = '';
    @Input() type: 'email' | 'link' | 'text';

    constructor() {}
}
